<template>
  <h3 class="cardTitle">{{content}}</h3>
</template>
<script>
  export default {
    name: 'cardTitle',
    props: [
      'content'
    ]
  }
</script>
<style>
h3.cardTitle {font-weight: bold; font-size: 12pt;}
</style>


// WEBPACK FOOTER //
// src/system/atoms/cardTitle.vue